import { Link } from "react-router-dom";
import { MessageCircle, ArrowLeft } from "lucide-react";
import { Button } from "../components/ui/button";

export default function Terms() {
  return (
    <div className="min-h-screen bg-background">
      <header className="sticky top-0 z-50 w-full border-b border-border bg-background/95 backdrop-blur">
        <div className="max-w-4xl mx-auto px-6 h-16 flex items-center gap-4">
          <Link to="/">
            <Button variant="ghost" size="icon" className="h-8 w-8">
              <ArrowLeft className="w-4 h-4" />
            </Button>
          </Link>
          <Link to="/" className="flex items-center gap-2">
            <img src="/brand/bicarra-icon.svg" alt="Bicarra" className="w-8 h-8 rounded-lg" />
            <span className="font-bold text-xl tracking-tight">BICARRA</span>
          </Link>
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-6 py-12" data-testid="terms-page">
        <h1 className="text-3xl font-bold tracking-tight mb-8">Terms of Service</h1>
        
        <div className="prose prose-neutral max-w-none space-y-6">
          <p className="text-muted-foreground">Last updated: January 15, 2026</p>

          <section className="space-y-4">
            <h2 className="text-xl font-semibold">1. Acceptance of Terms</h2>
            <p className="text-muted-foreground">
              By accessing and using BICARRA ("Service"), you accept and agree to be bound by the terms and provision of this agreement. If you do not agree to abide by the above, please do not use this service.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-xl font-semibold">2. Description of Service</h2>
            <p className="text-muted-foreground">
              BICARRA provides a platform for creating, training, and deploying AI-powered chatbots. The service includes chatbot creation, training data management, conversation handling, and analytics.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-xl font-semibold">3. User Responsibilities</h2>
            <p className="text-muted-foreground">
              You are responsible for maintaining the confidentiality of your account credentials and for all activities that occur under your account. You agree to notify us immediately of any unauthorized use of your account.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-xl font-semibold">4. Acceptable Use</h2>
            <p className="text-muted-foreground">
              You agree not to use the Service for any unlawful purpose or in any way that could damage, disable, or impair the Service. You may not use the Service to create chatbots that spread misinformation, harassment, or illegal content.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-xl font-semibold">5. Intellectual Property</h2>
            <p className="text-muted-foreground">
              The Service and its original content, features, and functionality are owned by BICARRA and are protected by international copyright, trademark, and other intellectual property laws.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-xl font-semibold">6. Termination</h2>
            <p className="text-muted-foreground">
              We may terminate or suspend your account and access to the Service immediately, without prior notice, for conduct that we believe violates these Terms or is harmful to other users, us, or third parties.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-xl font-semibold">7. Contact</h2>
            <p className="text-muted-foreground">
              If you have any questions about these Terms, please contact us at legal@bicarra.com
            </p>
          </section>
        </div>
      </main>
    </div>
  );
}
